import React from "react";
import {
  Box,
  Dialog,
  Typography,
  DialogContent,
  DialogActions,
  Button,
  Fade,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { isMobile } from "react-device-detect"; // Importar isMobile
import logo from "../assests/HorizontalFullColor.png";
import fondo from "../assests/Unicah01.jpg";

const ModalBienvenida = ({ nombre, openModalBienvenida }) => {
  const navigate = useNavigate();

  const handleStart = () => {
    navigate("/testVocacional");
  };

  return (
    <Dialog
  open={openModalBienvenida}
  scroll="paper"
  TransitionComponent={Fade}
  transitionDuration={800}
  sx={{
    "& .MuiDialog-container .MuiPaper-root": {
      width: isMobile ? "90%" : "95%", // Ancho diferente para móvil y web
          maxWidth: isMobile ? "500px" : "1200px", // Tamaño máximo diferente
      height: "auto", // Permitir que la altura se ajuste automáticamente
      borderRadius: "10px",
      backgroundImage: `url(${fondo})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  }}
>
  <DialogContent sx={{ display: "flex", justifyContent: "center", alignItems: "center", p: isMobile ? 2 : 4 }}>
    <Box
      position="relative"
      p={4}
      textAlign="center"
      sx={{
        backgroundColor: "rgba(0, 0, 0, 0.5)", // Fondo semi-transparente
        backdropFilter: "blur(10px)", // Efecto de desenfoque
        borderRadius: 2, // Bordes redondeados
        width: "100%", // Asegúrate de que el Box ocupe todo el ancho del DialogContent
        px: isMobile ? 2 : 4, // Ajustar padding interno
      }}
    >
      <Box position="absolute" top={isMobile ? 0 : 16}
            left={isMobile ? 0 : 16}
            transform={isMobile ? "translateX(-50%)" : "none"} // Centrar logo en móviles
            zIndex={1}>
        {!isMobile && ( // Mostrar el logo solo si NO es móvil
    <img
      width={150} // Tamaño del logo
      src={logo}
      alt="Logo"
    />
  )}
      </Box>

      <Typography
        className="animate__animated animate__bounceInDown"
        variant={isMobile ? "h4" : "h2"} 
        sx={{
          color: "white",
          mt: isMobile ? 4 : 6,
              mb: 4,
              textShadow: "2px 2px 4px black",
              textAlign: isMobile ? "center" : "justify", // Centrar texto en móviles
        }}
      >           
      </Typography>
      <Typography
              variant={isMobile ? "h4" : "h2"} // Cambiar tamaño según el dispositivo
              sx={{
                color: "white",
                mt: isMobile ? 3 : 6, // Margen superior menor en móviles
                mb: isMobile ? 2 : 4, // Margen inferior menor en móviles
                textShadow: "2px 2px 4px black", // Sombra del texto
                textAlign: "center", // Centrar el texto en ambas vistas
                fontSize: isMobile ? "1.0rem" : "2.5rem", // Ajustar tamaño de fuente
                fontWeight: "bold", // Hacer que el texto sea más destacado
              }}
            >
              ¡BIENVENIDO {nombre}!
            </Typography>

      <Typography
        fontSize={isMobile ? 10 : 18} // Cambiar tamaño del texto
        color="white"
        textAlign={isMobile ? "center" : "justify"} // Centrar texto en móviles
        mb={4}
        sx={{
          textShadow: `
            2px 2px 4px black,
            -1px -1px 2px black
          `,
        }}
      >
        <strong>
          Nos complace que estés aquí para dar el primer paso en la
          planificación de tu futuro académico y profesional. Sabemos que
          elegir una carrera universitaria es una de las decisiones más
          importantes de tu vida, y estamos aquí para guiarte en este
          proceso. A través de nuestras evaluaciones, podrás explorar tus
          intereses, descubrir tus habilidades y entender mejor tus
          aptitudes. Cada prueba que realices te brindará información
          valiosa sobre ti mismo, ayudándote a identificar las áreas en las
          que puedes destacar y aquellas en las que te sentirás más
          satisfecho.         
        </strong>
      </Typography>
      <Typography
        fontSize={isMobile ? 10 : 18}
        color="white"
        textAlign={isMobile ? "center" : "justify"}
        mb={4}
        sx={{
          textShadow: `
            2px 2px 4px black,
            -1px -1px 2px black
          `,
        }}
      >
        <strong>
        Instrucciones: "Este test vocacional está diseñado para ayudarte a identificar tus intereses, habilidades y áreas de afinidad profesional para orientarte en la elección de una carrera universitaria. Responde con sinceridad cada pregunta, seleccionando la opción que más se alinee con tus gustos, habilidades o preferencias personales. No hay respuestas correctas o incorrectas, ya que el objetivo es descubrir cuáles áreas académicas y profesionales se adaptan mejor a tus talentos e intereses. Dedica el tiempo necesario para reflexionar y completar cada sección con calma y honestidad."      
        </strong>
      </Typography>
     
    </Box>
  </DialogContent>
  <DialogActions
    sx={{ flexDirection: "column", alignItems: "center", py: 3 }}
  >
    <Button
      variant="contained"
      color="primary"
      size="large"
      onClick={handleStart}
    >
      Iniciar
    </Button>
    <Typography fontSize={12} color="#ccc" mt={2} textAlign="center">
      * Antes de comenzar, asegúrate de leer todas las instrucciones y
      preguntas cuidadosamente. Esto te ayudará a entender mejor lo que se
      espera de ti, asegúrate de estar en un lugar tranquilo y con el tiempo
      suficiente para completar el test sin interrupciones.
    </Typography>
  </DialogActions>
</Dialog>
  );
};

export default ModalBienvenida;

